import React, { Component } from "react";
import {
  Button,
  Card,
  CardBody,
  CardGroup,
  Col,
  Container,
  Form,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";

class loginWithOtp extends Component {
  render() {
    return (
      <CardBody className="m-3">
        <Form>
          <Row>
            <Col lg={12}>
              <h2 className="loginText">Login With OTP</h2>
            </Col>
            <Col lg={12}>
              <p className="Practitioner-text">Practitioners</p>
            </Col>
          </Row>
          <Row>
            <Col lg={10} md={12}>
              <InputGroup className="mb-1 mt-5">
                <InputGroupAddon addonType="prepend">
                  <InputGroupText className="inputGroupLogin">
                    <i className="bi bi-telephone-fill inputIconLogin"></i>
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  type="number"
                  name="contactNumber"
                  id="contactNumber"
                  placeholder="Enter mobile number"
                  onChange={this.props.onMobileChangeHandler}
                  value={this.props.mobileNumber}
                  pattern="[6-9]{1}[0-9]{9}"
                  maxLength={10}
                  minLength={10}
                  autocomplete="off"
                  className="loginOTPStyle inputTextFill"
                />
              </InputGroup>
            </Col>
          </Row>

          {/* {this.props.mobileNumber.length === 10 ? (
            <div className="text-center">
              <Button
                color="light"
                className="mt-3"
                onClick={() => this.props.sendOtpHandler()}
              >
                {this.props.otpButtonText}{" "}
                <i class="fa fa-paper-plane" aria-hidden="true"></i>
              </Button>
            </div>
          ) : (
            ""
          )} */}

          {this.props.verifySection === 1 &&
            this.props.mobileNumber.length === 10 && (
              <Row className="mt-1">
                <Col lg={10} md={12}>
                  <InputGroup className="mb-1">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText className="inputGroupLogin">
                        <i className="bi bi-chat-left-text-fill inputIconLogin"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      type="number"
                      name="verifyOtp"
                      id="verifyOtp"
                      placeholder="Enter OTP"
                      onChange={this.props.handleOnChange}
                      value={this.props.verifyOtp}
                      autocomplete="off"
                      className="loginOTPStyle inputTextFill"
                    />
                  </InputGroup>
                  {/* <div className="text-center">
                <Button color="light" className="mt-3">
                  Submit
                </Button>
              </div> */}
                </Col>
              </Row>
            )}

          {this.props.mobileNumber.length === 10 ? (
            <div>
              <span
                color="light"
                className="otpBtn"
                onClick={() => this.props.sendOtpHandler()}
              >
                {this.props.otpButtonText}{" "}
              </span>
            </div>
          ) : (
            ""
          )}
          <Row className="text-center">
            <Col xs="12" className="mb-3 mt-5" lg={10}>
              <Button
                className="colorOfBtn"
                onClick={(e)=>this.props.vendorOtpLogin(e)}
                color="warning"
              >
                Sign in
              </Button>
            </Col>
            <Col xs="12" lg={10}>
              <span
                className="createAccount paragraph-style"
                onClick={(e) => this.props.changeStatusHandler("0")}
              >
                I have an account
              </span>
            </Col>
          </Row>
        </Form>
        {/* <div className="text-center">
          Not Registered ?
          <span
            className="text-primary ml-2"
            style={{ cursor: "pointer" }}
            onClick={(e) => this.props.changeStatusHandler("2")}
          >
            Sign Up
          </span>
        </div> */}
      </CardBody>
    );
  }
}

export default loginWithOtp;
